'use strict';

// noinspection JSValidateTypes
/**
 * @ngdoc service
 * @name gfcmsApp.jobFactory
 * @description
 * # jobFactory
 * Factory in the gfcmsApp.
 */
angular.module('gfcmsApp').factory('jobFactory', jobFactory);

jobFactory.$inject = ['moment', 'momentService'];

/**
 * @typedef {Object} JobFactory
 * @property { (function(JobDto): Job) } create
 */

/**
 *
 * @param moment
 * @param momentService
 * @returns { JobFactory }
 */
function jobFactory(moment, momentService) {

  return {
    create: create
  };

  /**
   * @typedef {Object} Job
   * @property {String} address
   * @property {String} arrived
   * @property {Date} completeDate
   * @property {boolean} completed
   * @property {String} completedByUserId
   * @property {String} customerId
   * @property {String} customerContactNumber
   * @property {String} customerFirstName
   * @property {Number} dayId
   * @property {Number} duration
   * @property {String} end
   * @property {Moment} endMoment
   * @property {String} endDateTime
   * @property {String} homeId
   * @property {String} id
   * @property {String} jobDate
   * @property {Number} jobStatusId
   * @property {Array} logs
   * @property {String} notes
   * @property {String} orderId
   * @property {String} recipient
   * @property {String} scheduleId
   * @property {String} start
   * @property {Moment} startMoment
   * @property {String} startDateTime
   * @property {String} status
   * @property {String} title
   * @property {boolean} today
   * @property {number} timestamp
   * @property {boolean} stick
   * @property {boolean} canArrive
   * @property {boolean} canRecordAttempt
   * @property {boolean} isTerminal
   * @property {boolean} isToday
   * @property {boolean} isUpdating
   * @property {function()} updating
   * @property {function()} updated
   */

  /**
   * @param { JobDto } jobDto
   * @returns { Job }
   * @memberOf { JobFactory }
   */
  function create(jobDto) {
    return angular.extend(jobDto, {
      today: jobDto.dayId === getTodayDayId(),
      startMoment: moment(jobDto.start),
      endMoment: moment(jobDto.end),
      timestamp: moment(jobDto.start).valueOf(),
      stick: true,
      completed: !!jobDto.completeDate,
      canArrive: jobDto.canAcceptUpdate && !jobDto.arrived,
      canRecordAttempt: jobDto.canAcceptUpdate && !!jobDto.arrived,
      isTerminal: !jobDto.canAcceptUpdate,
      isToday: (jobDto.dayId === getTodayDayId()),
      isUpdating: false,
      /**
       * @function
       */
      updating: function () {
        this.isUpdating = true;
      },
      updated: function () {
        this.isUpdating = false;
      }
    });
  }

  /**
   * @return {number}
   */
  function getTodayDayId() {
    return momentService.getUtcDayId(moment());
  }
}
